/***
 * 描述：系统公共的wrapper容器部分
 */
import { Component, OnInit, ViewChild } from '@angular/core';
import { SwMenuService } from 'src/app/librarys/serves/sw-menu.service';
import { Title } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';
import {OninitService} from "../../librarys/serves/oninit.service";
import { ConfigurationService } from 'src/app/librarys/serves/public/configuration.service';
import { ActivatedRoute, ParamMap, Router, NavigationEnd, ActivationEnd } from '@angular/router';
import { SwMainComponent } from '../sw-main/sw-main.component';

@Component({
  selector: 'sw-home',
  templateUrl: './sw-home.component.html',
  styleUrls: ['./sw-home.component.css']
})
export class SwHomeComponent implements OnInit {
  @ViewChild('swMain') swMain: SwMainComponent;//模态框
  /**
   * 获取当前地址栏路径
   * @ignore
   */
  url:string

  /**
   * 默认的首页
   * @ignore
   */
  defaultHomePage:string  

  /**
   * 默认的需要全屏的页面
   * @ignore
   */
  fullScreenPage:string  

  /**
   * 判断是否需要全屏
   * @ignore
   */
  fullScreen:boolean = true 

  /**
   * 判断是否是单页签
   * @ignore
   */
  singleTab:boolean = false 

  /**
   * 路由订阅对象
   * @ignore
   */
  routerSubscriptiona:any

  /**
   * 全屏订阅对象
   * @ignore
   */
  isFullScreenSubscriptiona:any

  constructor(
    private MenuServe:SwMenuService,  //菜单服务
    private config:ConfigurationService,
    private titleService: Title , //浏览器头部信息
    private  init:OninitService,  //初始化服务
    private activatedRoute: ActivatedRoute,
    private router: Router
    ) { 
      this.fullScreenPage = environment.fullScreen
      this.defaultHomePage = environment.defaultPortal
      this.routerSubscriptiona = this.router.events.subscribe((event: NavigationEnd) => {
        if (event instanceof ActivationEnd) {  
          let path = "";
          for (let i = 0; event.snapshot["_urlSegment"].segments.length > i; i++) {
            if (event.snapshot["_urlSegment"].segments[i].path!="" ) {
              path = path + "/" +event.snapshot["_urlSegment"].segments[i].path
            }
          }
          this.url = path;
          if(this.defaultHomePage == path || this.fullScreenPage.indexOf(path) != -1 || this.fullScreenPage == '*'){
            //如果是需要全屏的页面或者是配置的首页,就要全屏
            this.MenuServe.isFullScreenUpdated.next({isFull:true,isInit:false})
          } else {
            // 不是配置的全屏页面，就不全屏,但是当左侧菜单没有数据的时候，还是需要全屏来隐藏左侧菜单
            let asideMenus = this.MenuServe.getMenusVal()
            //如果左侧菜单没数据 就将左侧菜单隐藏，即全屏
            if(!asideMenus || (asideMenus && !asideMenus["children"]) || (asideMenus && asideMenus["children"] && !asideMenus["children"]['length'])){
              //不存在左侧菜单数据，就全屏
              this.MenuServe.isFullScreenUpdated.next({isFull:true,isInit:false})
            } else {
              this.MenuServe.isFullScreenUpdated.next({isFull:false,isInit:false})
            }
          }
          this.MenuServe.singleTabUpdated.next(path)  //要更新单页签面包屑
        }
      });
    }

  ngOnDestroy(): void {
    if(this.routerSubscriptiona){
      this.routerSubscriptiona.unsubscribe()  //取消订阅
    }
    if(this.isFullScreenSubscriptiona){
      this.isFullScreenSubscriptiona.unsubscribe()  //取消订阅
    }
  }
  ngOnInit() {
    this.isFullScreenSubscriptiona = this.MenuServe.isFullScreenUpdated.subscribe(data=>{
      if(data['isInit'] == 1){
        //如果是最开始的初始化时，不管怎么样都要全屏
        this.fullScreen = true
      }else{
        if(data['isFull']){
          //如果需要全屏
          this.fullScreen = true
        } else {
          // 不需要全屏
          this.fullScreen = false
        }
      }
    })
    this.singleTab = environment.singleTab
  }
  emitToggle($event) {
    this.swMain.setTab()
  }
  ngAfterViewInit(){
    this.MenuServe.location(); //初始化菜单
    this.init.inItDictionary(); //初始化字典
    //this.init.inItToDos();//初始化待办事件
    this.init.inItNoitec(); //初始化通知信息
    this.init.setSystem(); //初始化系统id
    this.config.inItConfig(); //初始化配置文件
   // this.inItConfig();
  }

 //初始化配置文件
 inItConfig(){
  if(this.config.config){
    let loginSystem = this.config.config.find(x=>x.configKey =="SYS_PROJECT_NAME").configValue;
    this.titleService.setTitle(loginSystem);//修改浏览器头部
  }else{
    this.config.configpdated.subscribe(data=>{
      let loginSystem = data.find(x=>x.configKey =="SYS_PROJECT_NAME").configValue;
      this.titleService.setTitle(loginSystem);//修改浏览器头部
    })
  }

}

}
